import {Store} from '@/stores/Store';

export class ImageLoaderStore extends Store<{isShowItemsAndStatisticsImages: boolean}> {
  constructor() {
    super({isShowItemsAndStatisticsImages: false});
  }

  getIsShowItemsAndStatisticsImages(): boolean {
    return this.getState().isShowItemsAndStatisticsImages;
  }

  setShowItemsAndStatisticImages(showOtherImages: boolean): void {
    this.setState({...this.state, isShowItemsAndStatisticsImages: showOtherImages});
  }
}
